var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsaxSecuritySafe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_177_1551)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_177_1551",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0903 0H0V15.0903H15.0903V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_177_1551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.147 6.99193C13.147 10.0666 10.9149 12.9463 7.86538 13.7889C7.65788 13.8455 7.43147 13.8455 7.22397 13.7889C4.1745 12.9463 1.94238 10.0666 1.94238 6.99193V4.23165C1.94238 3.71606 2.33223 3.13131 2.81638 2.93639L6.31855 1.50283C7.10451 1.18216 7.99107 1.18216 8.77702 1.50283L12.2792 2.93639C12.7571 3.13131 13.1533 3.71606 13.1533 4.23165L13.147 6.99193Z",
    stroke: "url(#paint0_linear_177_1551)",
    strokeWidth: 1.00602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54464 7.85943C8.23917 7.85943 8.80216 7.29644 8.80216 6.6019C8.80216 5.90739 8.23917 5.34438 7.54464 5.34438C6.8501 5.34438 6.28711 5.90739 6.28711 6.6019C6.28711 7.29644 6.8501 7.85943 7.54464 7.85943ZM7.54464 7.85943V9.74572",
    stroke: "url(#paint1_linear_177_1551)",
    strokeWidth: 0.804818,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_177_1551",
    x1: 7.54783,
    y1: 1.26233,
    x2: 7.54783,
    y2: 13.8313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_177_1551",
    x1: 7.54464,
    y1: 5.34438,
    x2: 7.54464,
    y2: 9.74572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6D4F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_177_1551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0903,
    height: 15.0903,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsaxSecuritySafe);
export default __webpack_public_path__ + "static/media/iconsax-security-safe.50cec2c54896fe70739d2762e3fc60bb.svg";
export { ForwardRef as ReactComponent };